import React, { useEffect, useRef } from "react"

const TextareaComment = (props) => {
  const { currentAnswerValue, onChangeHandler, name } = props
  const textRef = useRef(null)

  useEffect(() => {
    if (textRef && textRef.current) {
      textRef.current.setSelectionRange(
        textRef.current.value.length,
        textRef.current.value.length
      )
    }
  }, [currentAnswerValue])

  return (
    <textarea
      data-cy={name + "-textarea"}
      ref={textRef}
      autoFocus
      rows={3}
      value={currentAnswerValue}
      onChange={(e) => onChangeHandler(e.target.value)}
    />
  )
}

export default TextareaComment
